import React, { useMemo } from 'react';
import cx from 'classnames';

import { useStandardCollator } from 'js/utils/string';

import styles from './CapabilityTrendsChart.module.scss';

function isFilterForCapability(filter, capabilityId) {
  return (
    filter &&
    filter.type === 'capability' &&
    filter.criteria.capabilityId === capabilityId
  );
}

function CapabilityTrendsLegend({
  paletteMap,
  capabilities,
  filterStack = {},
  onHoverCapability = () => {},
  onUnhoverCapability = () => {},
  onClickCapability = () => {},
}) {
  const collator = useStandardCollator();

  const sortedCapabilities = useMemo(() => {
    return Object.entries(capabilities || {}).sort((a, b) => {
      return (
        collator.compare(a[1].name, b[1].name) || collator.compare(a[0], b[0])
      );
    });
  }, [capabilities, collator]);

  if (!sortedCapabilities) {
    return null;
  }

  return (
    <ul className={styles['legend-list']}>
      {sortedCapabilities.map(([capabilityId, capability]) => {
        const isTransientFilter = isFilterForCapability(
          filterStack.transient,
          capabilityId
        );
        const isLockedFilter = isFilterForCapability(
          filterStack.locked,
          capabilityId
        );
        const isActiveFilter = isLockedFilter || isTransientFilter;
        return (
          <li
            key={capabilityId}
            className={cx(
              styles['legend-item'],
              paletteMap[capability.id]?.className,
              {
                'palette-muted': !isActiveFilter,
                active: isActiveFilter,
                [styles['transient']]: isTransientFilter,
                [styles['locked']]: isLockedFilter,
              }
            )}
            onMouseOver={() => onHoverCapability(capabilityId)}
            onMouseOut={() => onUnhoverCapability(capabilityId)}
            onClick={() => onClickCapability(capabilityId)}
          >
            <div className={cx(styles['legend-item-color'], 'palette-bg')} />
            <span className={styles['legend-item-label']}>
              {capability.name}
            </span>
          </li>
        );
      })}
    </ul>
  );
}

export default CapabilityTrendsLegend;
